import {BaseRoute, Route, routes} from '../types/routes';

export const getRoute = (): Route => {
  if(window.location.pathname === '/contact') return '/support';
  if(window.location.pathname.startsWith('/projects/')) return window.location.pathname as Route;

  const path = window.location.pathname as BaseRoute;
  return routes.includes(path) ? path : '/';
};

export const scrollToPageTop = () => {
  window.scrollTo({left: 0, top: 0});
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export const navigate = (route: Route) => {
  window.history.pushState({}, '', route);
  window.dispatchEvent(new PopStateEvent('popstate'));
  document.documentElement.classList.add('is-route-jump');
  scrollToPageTop();
  window.requestAnimationFrame(() => document.documentElement.classList.remove('is-route-jump'));
};
